import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

export default function AdminServiceInquiries() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [replies, setReplies] = useState({});
    const [savingId, setSavingId] = useState(null);

    const load = () => {
        setLoading(true);
        adminFetch(`${API_BASE}/api/get_service_enquiries.php`)
            .then((r) => r.json())
            .then((data) => { if (data.success) setRows(data.enquiries); })
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const respond = async (id, status) => {
        setSavingId(id);
        try {
            const res = await adminFetch(`${API_BASE}/api/reply_service_enquiry.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id, status, admin_reply: replies[id] ?? "" }),
            });
            const data = await res.json();
            if (data.success) load();
        } finally {
            setSavingId(null);
        }
    };

    const badge = (status) => {
        const map = { pending: "warning", replied: "success", closed: "secondary" };
        return <span className={`badge bg-${map[status] || "secondary"}`}>{status}</span>;
    };

    return (
        <div>
            <h5 className="fw-bold mb-1">Service Inquiries</h5>
            <p className="text-secondary small mb-3">
                Enquiries submitted from the category tiles on the homepage (e.g. "Plumber", "Electrician").
            </p>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : rows.length === 0 ? (
                        <div className="p-3 text-secondary">No inquiries yet.</div>
                    ) : (
                        <table className="table table-sm mb-0 align-middle">
                            <thead className="table-light">
                                <tr><th>Category</th><th>Name / Mobile</th><th>Message</th><th>Status</th><th>Reply</th><th></th></tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id}>
                                        <td><span className="badge bg-info text-dark">{r.category}</span></td>
                                        <td className="small">{r.full_name}<br /><span className="text-secondary">{r.mobile}</span></td>
                                        <td className="small" style={{ maxWidth: 220 }}>{r.message || <span className="text-secondary">—</span>}</td>
                                        <td>{badge(r.status)}</td>
                                        <td style={{ minWidth: 200 }}>
                                            <textarea
                                                className="form-control form-control-sm"
                                                rows="2"
                                                placeholder="Type a reply..."
                                                defaultValue={r.admin_reply || ""}
                                                onChange={(e) => setReplies((n) => ({ ...n, [r.id]: e.target.value }))}
                                            />
                                        </td>
                                        <td style={{ whiteSpace: "nowrap" }}>
                                            <div className="btn-group btn-group-sm">
                                                <button className="btn btn-outline-success" disabled={savingId === r.id} onClick={() => respond(r.id, "replied")}>Send Reply</button>
                                                <button className="btn btn-outline-secondary" disabled={savingId === r.id} onClick={() => respond(r.id, "closed")}>Close</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
